var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNorthCarolina(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "288px",
    height: "288px",
    viewBox: "0 0 288 288",
    style: {
      enableBackground: "new 0 0 288 288"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M258.123,112.08c-4.863-4.351-12.03-21.503-12.03-21.503s-51.505,11.847-69.63,15.104 c-19.635,3.526-81.404,12.031-81.404,12.031h-5.375v9.217c0,0-5.121,2.56-7.682,9.214c0,0-5.119-0.766-6.654,0.768 c-0.857,0.859-3.072,2.595-4.86,3.958c-1.414,1.081-2.563,1.93-2.563,1.93l-0.458-1.489l-2.615,0.382l-4.863,5.267l-0.767,4.543 c0,0-6.657,1.023-9.986,5.376c-3.327,4.351-10.751,4.351-13.823,7.681c-3.07,3.326-3.584,8.191-3.584,8.191 s-5.375,0.512-5.889,2.047c-0.512,1.535-1.022,7.68-1.022,7.68l33.023-3.328c0,0-0.516,0.628-1.191,1.574l24.484-12.324 c0,0,36.607-2.816,37.632-2.688c1.023,0.127,6.145,8.063,6.145,8.063l27.392-3.072l38.397,24.831c0,0-0.402,0.203-1.405,0.976 c8.796-2.572,17.02-4.814,17.02-4.814s0.514-9.984,11.008-21.504c10.495-11.518,24.064-11.775,24.064-11.775l9.214-13.567 c-5.63,3.327-13.821,2.56-13.821,2.56l2.305-9.472l-4.099-1.812l-0.255-4.075c0,0,3.838,2.303,6.142,3.839 c2.307,1.537,9.217-4.864,9.217-5.631c0-0.77,2.305-5.375,5.122-6.911c2.815-1.537-0.769-7.937,0.254-7.937 C256.588,115.408,262.988,116.433,258.123,112.08z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNorthCarolina);
export default __webpack_public_path__ + "static/media/northCarolina.58a699f6409d1a2e7df08b2fac6c102c.svg";
export { ForwardRef as ReactComponent };